// Quick sizes for Resize (FR-21), including common Indian exam-portal sizes.
import { toPixels } from "@/lib/image/size";

export type SizePreset = {
  id: string;
  label: string;
  width: number;
  height: number;
  /** Also turn on "keep under" with this many KB. */
  maxKB?: number;
  /** Print resolution saved in the JPG (passport photos). */
  dpi?: number;
};

export const SIZE_PRESETS: SizePreset[] = [
  {
    id: "passport",
    label: "Passport 35×45 mm",
    width: toPixels(3.5, "cm", 300), // 413
    height: toPixels(4.5, "cm", 300), // 531
    dpi: 300,
  },
  {
    id: "exam-photo",
    label: "Exam photo 200×230",
    width: 200,
    height: 230,
    maxKB: 50,
  },
  {
    id: "exam-signature",
    label: "Exam signature 140×60",
    width: 140,
    height: 60,
    maxKB: 20,
  },
  {
    id: "instagram-post",
    label: "Instagram post 1080×1080",
    width: 1080,
    height: 1080,
  },
  {
    id: "instagram-story",
    label: "Instagram story 1080×1920",
    width: 1080,
    height: 1920,
  },
  {
    id: "youtube",
    label: "YouTube thumbnail 1280×720",
    width: 1280,
    height: 720,
  },
];
